import { Cube } from "~/components/onboarding/use-onboarding-cubes";

export const shuffleIndices = (length: number): number[] => {
  const indices = Array.from({ length }, (_, i) => i);
  for (let i = indices.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = indices[i];
    indices[i] = indices[j] ?? 0;
    indices[j] = temp ?? 0;
  }
  return indices;
};

export const shuffleCubes = (availableCubes: Cube[], cubesLength: number, batchSize: number): (Cube | undefined)[] => {
  const indices = shuffleIndices(cubesLength);
  const selectedIndices = indices.slice(0, batchSize);
  const selectedCubes = selectedIndices.sort((a, b) => b - a).map((index) => availableCubes.splice(index, 1)[0]);
  return selectedCubes;
};
